export const printBill = (order, payment, { receipt_number = null } = {}) => {
  const billWindow = window.open('', '_blank', 'width=300,height=500');
  
  const currentDate = new Date();
  const billNumber = receipt_number || Math.random().toString(36).substr(2, 9).toUpperCase();

  // Format split payment details for receipt - FIXED VERSION
  const getPaymentDetails = () => {
    if (payment.payment_method === 'split') {
      // Use cash_amount and card_amount directly from payment object
      const cashAmount = payment.cash_amount || 0;
      const cardAmount = payment.card_amount || 0;
      
      return `
        <div class="payment-info split-payment">
          <div class="payment-method">Payment: SPLIT PAYMENT</div>
          <div>Cash: LKR ${cashAmount.toFixed(2)}</div>
          <div>Card: LKR ${cardAmount.toFixed(2)}</div>
          <div>Total: LKR ${payment.total_amount.toFixed(2)}</div>
          ${payment.transaction_id ? `<div>Transaction: ${payment.transaction_id}</div>` : ''}
          ${payment.card_last_four ? `<div>Card: **** ${payment.card_last_four}</div>` : ''}
          ${payment.card_brand ? `<div>Brand: ${payment.card_brand.toUpperCase()}</div>` : ''}
        </div>
      `;
    } else if (payment.payment_method === 'cash') {
      const tenderAmount = payment.tender_amount || payment.total_amount;
      const changeAmount = payment.change_amount || (tenderAmount - payment.total_amount);
      
      return `
        <div class="payment-info">
          <div class="payment-method">Payment: CASH</div>
          <div>Tender: LKR ${tenderAmount.toFixed(2)}</div>
          <div>Change: LKR ${changeAmount.toFixed(2)}</div>
        </div>
      `;
    } else if (payment.payment_method === 'card') {
      return `
        <div class="payment-info">
          <div class="payment-method">Payment: CARD</div>
          <div>Amount: LKR ${payment.total_amount.toFixed(2)}</div>
          ${payment.transaction_id ? `<div>Transaction: ${payment.transaction_id}</div>` : ''}
          ${payment.card_last_four ? `<div>Card: **** ${payment.card_last_four}</div>` : ''}
          ${payment.card_brand ? `<div>Brand: ${payment.card_brand.toUpperCase()}</div>` : ''}
        </div>
      `;
    } else if (['bank_transfer', 'mobile'].includes(payment.payment_method)) {
      return `
        <div class="payment-info">
          <div class="payment-method">Payment: ${payment.payment_method.toUpperCase()}</div>
          <div>Amount: LKR ${payment.total_amount.toFixed(2)}</div>
          ${payment.transaction_id ? `<div>Transaction: ${payment.transaction_id}</div>` : ''}
        </div>
      `;
    } else {
      return `
        <div class="payment-info">
          <div class="payment-method">Payment: ${payment.payment_method.toUpperCase()}</div>
          <div>Amount: LKR ${payment.total_amount.toFixed(2)}</div>
        </div>
      `;
    }
  };

  const billContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>Light Grocer Super Market - Bill</title>
      <style>
        @media print {
          body { 
            margin: 0 !important; 
            padding: 0 !important;
            height: auto !important;
            overflow: visible !important;
          }
          .no-print { display: none !important; }
          .bill-container { 
            page-break-after: avoid;
            height: auto !important;
            max-height: none !important;
          }
        }
        
        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }
        
        body {
          font-family: 'Courier New', monospace;
          font-size: 12px;
          margin: 0;
          padding: 8px;
          width: 280px;
          height: auto !important;
          min-height: auto !important;
          line-height: 1.2;
          overflow: visible !important;
        }
        
        .bill-container {
          width: 100%;
          height: auto !important;
          min-height: auto !important;
        }
        
        .logo-container {
          text-align: center;
          margin-bottom: 8px;
          padding-bottom: 8px;
          border-bottom: 2px solid #000;
        }
        
        .logo {
          max-width: 120px;
          height: auto;
          display: inline-block;
        }
        
        .header {
          text-align: center;
          margin-bottom: 8px;
        }
        
        .store-name {
          font-weight: 900;
          font-size: 18px;
          margin: 4px 0;
          line-height: 1.1;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        .store-address {
          font-weight: 700;
          font-size: 10px;
          margin: 2px 0;
          line-height: 1.1;
        }
        
        .bill-info {
          display: flex;
          justify-content: space-between;
          margin: 6px 0;
          font-size: 10px;
          font-weight: 700;
        }
        
        .bill-info div {
          flex: 1;
        }
        
        .bill-info div:last-child {
          text-align: right;
        }
        
        .items-table {
          width: 100%;
          border-collapse: collapse;
          margin: 8px 0;
          font-weight: 700;
        }
        
        .items-table th {
          text-align: left;
          border-bottom: 2px solid #000;
          padding: 4px 2px;
          font-size: 10px;
          font-weight: 900;
          text-transform: uppercase;
        }
        
        .items-table td {
          padding: 4px 2px;
          border-bottom: 1px solid #ccc;
          font-size: 10px;
          font-weight: 700;
          vertical-align: top;
        }
        
        .item-name {
          width: 55%;
          word-break: break-word;
        }
        
        .item-qty {
          width: 15%;
          text-align: center;
          font-weight: 900;
        }
        
        .item-price {
          width: 30%;
          text-align: right;
          font-weight: 900;
        }
        
        .total-section {
          border-top: 3px double #000;
          margin-top: 8px;
          padding-top: 8px;
        }
        
        .total-row {
          display: flex;
          justify-content: space-between;
          margin: 3px 0;
          font-weight: 900;
          font-size: 11px;
        }
        
        .grand-total {
          font-size: 12px;
          border-top: 1px solid #000;
          padding-top: 4px;
          margin-top: 4px;
        }
        
        .payment-info {
          margin: 8px 0;
          padding: 6px;
          background: #f0f0f0;
          border-radius: 3px;
          border: 1px solid #ccc;
          font-weight: 700;
        }
        
        .payment-info div {
          margin: 2px 0;
          font-size: 10px;
        }
        
        .payment-method {
          font-weight: 900;
          text-transform: uppercase;
          font-size: 11px;
        }
        
        .split-payment {
          background: #fffacd;
          border: 1px solid #ffd700;
        }
        
        .card-payment {
          background: #e6f3ff;
          border: 1px solid #007bff;
        }
        
        .footer {
          text-align: center;
          margin-top: 10px;
          border-top: 2px solid #000;
          padding-top: 8px;
          font-size: 9px;
          font-weight: 700;
          line-height: 1.1;
        }
        
        .barcode {
          text-align: center;
          margin: 8px 0;
          font-family: 'Courier New', monospace;
          font-size: 16px;
          font-weight: 900;
          letter-spacing: 2px;
        }
        
        .thank-you {
          text-align: center;
          font-weight: 900;
          margin: 8px 0;
          font-size: 11px;
          text-transform: uppercase;
          padding: 4px;
          border: 1px solid #000;
          background: #f0f0f0;
        }
        
        .divider {
          border-bottom: 1px dashed #000;
          margin: 6px 0;
        }
        
        .no-print {
          margin-top: 15px;
          text-align: center;
          padding-top: 10px;
          border-top: 1px solid #ccc;
        }
        
        .no-print button {
          padding: 8px 16px;
          font-size: 12px;
          cursor: pointer;
          margin: 0 5px;
          border: 1px solid #ccc;
          background: #f0f0f0;
          border-radius: 3px;
          font-weight: 700;
        }
        
        /* Compact styles for fewer items */
        .compact .items-table {
          margin: 6px 0;
        }
        
        .compact .header {
          margin-bottom: 6px;
          padding-bottom: 6px;
        }
        
        .compact .footer {
          margin-top: 8px;
          padding-top: 6px;
        }
      </style>
    </head>
    <body>
      <div class="bill-container ${order.length <= 3 ? 'compact' : ''}">
        <div class="logo-container">
          <img src="/logo.svg" alt="Lite Grocer Logo" class="logo">
        </div>
        
        <div class="header">
          <div class="store-name">LITE GROCER SUPER MARKET</div>
          <div class="store-address">No.65, galle rd walana Panadura.</div>
          <div class="store-address">Tel: +94 71 608 2005</div>
        </div>
        
        <div class="divider"></div>
        
        <div class="bill-info">
          <div>Date: ${currentDate.toLocaleDateString()}</div>
          <div>Time: ${currentDate.toLocaleTimeString()}</div>
        </div>
        
        <div class="bill-info">
          <div>Bill No: ${billNumber}</div>
          <div>Cashier: ${localStorage.getItem('cashier_user') ? JSON.parse(localStorage.getItem('cashier_user')).full_legal_name : 'System'}</div>
        </div>
        
        <div class="divider"></div>
        
        <table class="items-table">
          <thead>
            <tr>
              <th class="item-name">Item</th>
              <th class="item-qty">Qty</th>
              <th class="item-price">Amount</th>
            </tr>
          </thead>
          <tbody>
            ${order.map(item => `
              <tr>
                <td class="item-name">${item.name.length > 25 ? item.name.substring(0, 25) + '...' : item.name}</td>
                <td class="item-qty">${item.quantity}</td>
                <td class="item-price">LKR ${(item.price * item.quantity).toFixed(2)}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
        
        <div class="total-section">
          <div class="total-row">
            <span>Subtotal:</span>
            <span>LKR ${payment.total_amount.toFixed(2)}</span>
          </div>
          <div class="total-row grand-total">
            <span>TOTAL:</span>
            <span>LKR ${payment.total_amount.toFixed(2)}</span>
          </div>
        </div>
        
        ${getPaymentDetails()}
        
        <div class="barcode">
          ${billNumber}
        </div>
        
        <div class="thank-you">
          Thank you for shopping with us!
        </div>
        
        <div class="footer">
          <div>Items sold are not returnable</div>
          <div>Prices include VAT where applicable</div>
          <div>www.lightgrocer.com</div>
        </div>
        
        <div class="no-print">
          <button onclick="window.print()">🖨️ Print Bill</button>
          <button onclick="window.close()">❌ Close</button>
        </div>
      </div>
      
      <script>
        // Auto-resize window to fit content
        setTimeout(() => {
          const body = document.body;
          const html = document.documentElement;
          
          // Calculate the actual content height
          const height = Math.max(
            body.scrollHeight,
            body.offsetHeight,
            html.clientHeight,
            html.scrollHeight,
            html.offsetHeight
          );
          
          // Resize the window to fit content exactly
          window.resizeTo(300, height + 20); // Add small buffer
          
          // Auto-print for thermal printers
          setTimeout(() => {
            window.print();
            
            // Close window after print (for thermal printers)
            setTimeout(() => {
              if (window.matchMedia && window.matchMedia('print').matches) {
                window.close();
              }
            }, 1000);
          }, 500);
        }, 100);
        
        // Close window if user presses Escape key
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape') {
            window.close();
          }
        });
      </script>
    </body>
    </html>
  `;

  billWindow.document.write(billContent);
  billWindow.document.close();
};